import { render, staticRenderFns } from "./selectProduct.vue?vue&type=template&id=0bf550b4&scoped=true&"
import script from "./selectProduct.vue?vue&type=script&lang=js&"
export * from "./selectProduct.vue?vue&type=script&lang=js&"
import style0 from "./selectProduct.vue?vue&type=style&index=0&id=0bf550b4&prod&lang=css&"
import style1 from "./selectProduct.vue?vue&type=style&index=1&id=0bf550b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf550b4",
  null
  
)

export default component.exports